export default "__VITE_ASSET__EgxtCfwl__"